import styled from 'styled-components';

export const Wrapper = styled.div`
  > * {
    margin-right: ${({ theme }) => theme.spacing.s2};

    &:last-child {
      margin-right: 0;
    }
  }
`;
